import { render } from "./blog-grid.vue?vue&type=template&id=713ed3be"
import script from "./blog-grid.vue?vue&type=script&lang=js"
export * from "./blog-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__